import React, { useEffect, useState } from "react";
import { Form, Button, Image, Modal, Row, Col, InputGroup } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { deleteProfileStart } from "../../store/slices/AdminSlice";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form as FORM, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ButtonLoader } from "../Helper/Loader";
import useLogout from "../../hooks/useLogout";
import { useTranslation } from "react-multi-lang";

const DeleteAccountModal = (props) => {

  const dispatch = useDispatch();
  const t = useTranslation("delete_account");
  const deleteProfile = useSelector((state) => state.admin.deleteProfile);
  const [skipRender, setSkipRender] = useState(true);
  const {logout} = useLogout();
  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    password: Yup.string().matches(/^(?=.*[a-zA-Z0-9])(?=.{6,})/, t("password.invalid"))
      .required(t("password.required"))
  });

  const handleSubmit = (values) => {
    dispatch(deleteProfileStart(values))
  };

  useEffect(()=> {
    if(!skipRender && !deleteProfile.loading && Object.keys(deleteProfile.data).length > 0)
    {
      props.closeDeleteAccountModal();
      logout();
    }

    setSkipRender(false);
  }, [deleteProfile])


  return (
    <>
      <Modal
        className="modal-dialog-center payment-link-created-modal"
        size="md"
        centered
        show={props.deleteAccount}
        onHide={props.closeDeleteAccountModal}
      >
        <Modal.Body>
          <Button
            onClick={props.closeDeleteAccountModal}
            className="modal-close"
          >
            <Image
              className="close-icon"
              src={window.location.origin + "/img/close-modal-icon.svg"}
            />
          </Button>
          <div className="add-bank-account-modal-sec">
          <div className="settlement-top-sec">
            <h3>{t("heading")}</h3>
          </div>
          <Row className="align-items-center">
            <Col md={12}>
                <div className="bank-account-form-sec">
                <Formik
                    initialValues={{
                      password: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ values, setFieldValue }) => (
                      <FORM className="efi-auth-form">
                        <div className="mb-3">
                          <Form.Label htmlFor="basic-url"> {t("password.label")}</Form.Label>
                          <InputGroup>
                            <Field
                              className="form-control"
                              placeholder={t("password.placeholder")}
                              type={showPassword ? "text" : "password"}
                              name="password"
                            />
                            <InputGroup.Text id="basic-addon3">
                              <Button className="hide-btn" onClick={()=> setShowPassword(!showPassword)}>
                                {!showPassword ? <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye" fill="none" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#666" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg> : 
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#666" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" /><path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" /><path d="M3 3l18 18" /></svg>}
                              </Button>
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMessage
                            component={"div"}
                            name="password"
                            className="errorMsg"
                          />
                        </div>
                        <div className="request-payout-payment-method-btn-sec">
                          <Button className="efi-cancel-btn" onClick={()=> {setFieldValue("password", "")}}>
                           {t("reset")}
                          </Button>
                          <Button className="efi-auth-btn" disabled={deleteProfile.buttonDisable} type="submit">{deleteProfile.buttonDisable ? <ButtonLoader/>: t("delete_btn.text")}</Button>
                        </div>
                      </FORM>
                    )}
                  </Formik>
                </div>
            </Col>
          </Row>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteAccountModal;
